export default __webpack_public_path__ + "65f7ba72e6c0645f0f9180580b1a9b7f.svg";